<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <p v-if="header">
          <span>COPYRIGHT &copy;</span>
          <span>{{ new Date().getFullYear() }} </span>
          <a :href="get_url" target="_blank" rel="nofollow">{{get_title}}</a>
          <span class="hidden sm:inline-block">, All rights Reserved</span>
        </p>
        <!-- <span class="md:flex hidden items-center">
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span> -->
        <chatlive v-if="liveChat"
        v-bind:dataset="company" ></chatlive>
    </footer>
</template>

<script>
import ChatLive from '../../components/chat-live/chat-live';



export default {
    name: "the-footer",
    data(){
      return{
        company: {},
      }
    },
    components: {
      chatlive: ChatLive,
    },
    props: {
        classes: {
            type: String,
        },
        header: {
          default: false
        }
    },
    computed: {
      liveChat() {
        return this.departmentWalkinStaffIds.length > 0;
      },
      departmentWalkinStaffIds() {
        const department_id = this.company.live_chat_department_id;
        return this.$store.state.department.available_staff_ids[department_id] || [];
      }, 
      get_title() {
        return this.$store.getters.whitelabel.copyright_text;
      },
      get_url() {
        return this.$store.getters.whitelabel.live_url;
      },
      company_slug() {
        return this.$route.params.slug;
      }
 },
 beforeDestroy() {
  window.Echo.leaveChannel('embedLiveChatOnOff');
 },
 created(){
  this.getCompanyDetails();

  window.Echo.channel('embedLiveChatOnOff')
  .listen('EmbedLiveChatOnOff', res => {
    if(res.data.slug == this.slug || res.data.company_id == this.company.id) {
      console.log('EmbedLiveChatOnOff', res)
      this.getCompanyDetails();
    }
  })
 },
 methods:{
  getCompanyDetails() {
      this.success = "";
      this.error = "";
      let slug = this.company_slug
      console.log("slug", slug)
      this.show = true;
      this.$store
        .dispatch("CompanyDetails", slug)
        .then((res) => {
          this.show = false;
          if (res.data.status == "success") {
            this.company = res.data.data;
            const liveChatDepartment = res.data.data.live_chat_department;
            if(liveChatDepartment)
              this.$store.dispatch('initDepartmentStaffOnline', liveChatDepartment.id);
            this.errorMsg = false;
          } else {
            this.errorMsg = true;
          }

        })
        .catch((error) => {
          this.$log.error(
            "File : Welcome.vue | Function : getCompanyDetails() | Error :",
            error
          );
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
 },
  watch: {
    availableStaffIds() {
      this.checkStartMeeting();
    }
  }
}
</script>
